<script setup lang="ts">
import type { SiteSettingContentQuickLinkObject } from 'types';

defineProps<{
  addressInformation: AddressObject[];
  quickLinks: SiteSettingContentQuickLinkObject[];
}>();
</script>

<template>
  <section>
    <AccordionRoot
      v-if="addressInformation || (Array.isArray(quickLinks) && quickLinks.length > 0)"
      type="single"
      :collapsible="true"
      class="grid gap-4"
    >
      <PartialsAccordionItem
        :title="$t('Footer.ContactDepartment')"
        :accordion-item-index="0"
        :white-text="true"
      >
        <AddressInformation :address="addressInformation[0]" />
      </PartialsAccordionItem>
      <PartialsAccordionItem
        v-for="(quickLink, index) in quickLinks"
        :key="`${quickLink.content.headline}-${index}`"
        :title="quickLink.content.headline"
        :accordion-item-index="index"
        :white-text="true"
      >
        <PartialsAccordionContentFooterColumn :quick-link-content="quickLink.content" />
      </PartialsAccordionItem>
    </AccordionRoot>
  </section>
</template>
